import React from "react";
import { Scale } from "lucide-react";

import HeaderRobotsBtn from "../../../components/Header/RobotsBtn";
import HeaderSupportBtn from "../../../components/Header/SupportBtn";
import HeaderProfileBtn from "../../../components/Header/ProfileBtn";
import Header from "../../../components/Header";

import ShareButton from "../../../components/ShareButton";

import { useLawyerFeeCalculator } from "../../../components/Calculator/LawyerFeeCalculator/hooks/useLawyerFeeCalculator";
import CaseTypeSelector from "../../../components/Calculator/LawyerFeeCalculator/CaseTypeSelector";
import UnitSwitcher from "../../../components/Calculator/LawyerFeeCalculator/UnitSwitcher";
import FinancialForm from "../../../components/Calculator/LawyerFeeCalculator/forms/FinancialForm";
import NonFinancialNotice from "../../../components/Calculator/LawyerFeeCalculator/forms/NonFinancialNotice";
import CriminalForm from "../../../components/Calculator/LawyerFeeCalculator/forms/CriminalForm";
import ExecutionForm from "../../../components/Calculator/LawyerFeeCalculator/forms/ExecutionForm";
import SpecializedForm from "../../../components/Calculator/LawyerFeeCalculator/forms/SpecializedForm";
import ModifiersFields from "../../../components/Calculator/LawyerFeeCalculator/forms/ModifiersFields";
import ResultsPanel from "../../../components/Calculator/LawyerFeeCalculator/results/ResultsPanel";
import { buildLawyerFeeShareText } from "../../../components/Calculator/LawyerFeeCalculator/utils/shareText";

export default function LawyerFeeCalculator() {
  const {
    caseType,
    setCaseType,
    unit,
    setUnit,
    financialBasis,
    setFinancialBasis,
    claimAmount,
    setClaimAmount,
    agreedFee,
    setAgreedFee,
    termination,
    setTermination,
    education,
    setEducation,
    experience,
    setExperience,
    cityTier,
    setCityTier,
    criminalTier,
    setCriminalTier,
    repeatCounts,
    setRepeatCounts,
    association,
    setAssociation,
    executionAmount,
    setExecutionAmount,
    specializedAmount,
    setSpecializedAmount,
    unitLabel,
    result,
    toDisplay,
  } = useLawyerFeeCalculator();

  const showModifiers =
    (caseType === "financial" && financialBasis === "tariff") ||
    caseType === "nonFinancial" ||
    caseType === "criminal";

  const shareText = result
    ? buildLawyerFeeShareText({
        caseType,
        unit,
        unitLabel,
        result,
        toDisplay,
        financialBasis,
        claimAmount,
        agreedFee,
        termination,
        criminalTier,
        repeatCounts,
        executionAmount,
        association,
        specializedAmount,
        education,
        experience,
        cityTier,
      })
    : "";

  return (
    <div className="max-w-3xl mx-auto px-4 py-24">
      <Header title={"وکیل‌ سان"}>
        <HeaderRobotsBtn />
        <HeaderSupportBtn />
        <HeaderProfileBtn />
      </Header>

      {/* هدر */}
      <div className="mb-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs mb-4 bg-neutral-800 text-neutral-200">
          <Scale size={14} />
          <span>بر مبنای آیین‌نامه تعرفه حق‌الوکاله و ماده ۱۰۳ ق.م.م.</span>
        </div>
        <h1 className="text-3xl font-bold mb-2">
          محاسبه‌گر حق‌الوکاله و تمبر مالیاتی
        </h1>
        <p className="text-sm">
          نوع دعوا را انتخاب کنید تا حق‌الوکاله و مبلغ تمبر مالیاتی مربوطه
          محاسبه شود.
        </p>
      </div>

      {/* انتخاب نوع دعوا */}
      <CaseTypeSelector caseType={caseType} onChange={setCaseType} />

      <div className="w-full flex justify-between items-center mb-4">

        {result && (
          <ShareButton
            text={shareText}
            title="محاسبه حق‌الوکاله و تمبر مالیاتی"
          />
        )}
        {/* واحد ورودی — ریال در اولویت است */}
        <UnitSwitcher unit={unit} onChange={setUnit} />
      </div>

      {/* کارت فرم */}
      <div className="rounded-2xl p-6 mb-6 bg-primary/10">
        {caseType === "financial" && (
          <FinancialForm
            unitLabel={unitLabel}
            financialBasis={financialBasis}
            setFinancialBasis={setFinancialBasis}
            claimAmount={claimAmount}
            setClaimAmount={setClaimAmount}
            agreedFee={agreedFee}
            setAgreedFee={setAgreedFee}
            termination={termination}
            setTermination={setTermination}
          />
        )}

        {caseType === "nonFinancial" && <NonFinancialNotice />}

        {caseType === "criminal" && (
          <CriminalForm
            criminalTier={criminalTier}
            setCriminalTier={setCriminalTier}
            repeatCounts={repeatCounts}
            setRepeatCounts={setRepeatCounts}
          />
        )}

        {caseType === "execution" && (
          <ExecutionForm
            unitLabel={unitLabel}
            executionAmount={executionAmount}
            setExecutionAmount={setExecutionAmount}
            association={association}
            setAssociation={setAssociation}
          />
        )}

        {caseType === "specialized" && (
          <SpecializedForm
            unitLabel={unitLabel}
            specializedAmount={specializedAmount}
            setSpecializedAmount={setSpecializedAmount}
          />
        )}

        {showModifiers && (
          <ModifiersFields
            education={education}
            setEducation={setEducation}
            experience={experience}
            setExperience={setExperience}
            cityTier={cityTier}
            setCityTier={setCityTier}
          />
        )}
      </div>

      {/* نتیجه */}
      <ResultsPanel
        result={result}
        toDisplay={toDisplay}
        unitLabel={unitLabel}
      />
    </div>
  );
}
